import { numberSorter } from '../sorters';

type Epoc = number;
type HasCreatedAt = { createdAt?: Epoc | null };
export const byCreatedAt = (a?: HasCreatedAt, b?: HasCreatedAt): number =>
  numberSorter(a?.createdAt, b?.createdAt);
